export default __webpack_public_path__ + "b8001277e44211e063db8df11c44b5c5.svg";